export const AGENT_BREADCRUMBS = [
  { title: "Inicio", path: "/" },
  { title: "Gestión de agentes" },
];

export const ROLE_OPTIONS = [
  { value: 'todos', label: 'Todos los roles' },
  { value: 'Administrator', label: 'Administrador' },
  { value: 'User', label: 'Usuario' },
];

export const STATUS_OPTIONS = [
  { value: 'todos', label: 'Todos los estados' },
  { value: 'Activo', label: 'Activo' },
  { value: 'Inactivo', label: 'Inactivo' },
];

export const SUBROLE_OPTIONS = [
  { value: 'Owner', label: 'Owner' },
];

export const AVAILABILITY_OPTIONS = [
  { value: 'Activo', label: 'Activo' },
  { value: 'Inactivo', label: 'Inactivo' },
];
